import React, { Component } from "react";

import "./style.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

// Icons
import IconStart from "@learningblocks/protocol-constants/lib/Icons/start-solid";
import ProtocolOverviewIcon from "./img/ProtocolOverview-icon.svg";

export class ProtocolOverview extends Component {
  start = () => {
    this.props.showModal({display: false});
  };

  render() {
    return (
      <div className="modal-section level-choice">
        <img src={ProtocolOverviewIcon} style={{height: "130px"}} alt="Protocol Overview icon" />
        <div className="modal-header">
          <h2 tabIndex={0}>Read through the protocol</h2>
        </div>
        <ol style={{ padding: "0 0 0 16px" }}>
          {this.props.sequence.map((step) => {
            return (
              <li style={{ marginBottom: "16px" }} tabIndex={0}>
                {step.label}
              </li>
            );
          })}
        </ol>
        <div className="modal-footer lvl-choice">
          <button
            aria-label="Start simulation button"
            className="modal-btn-primary lvl-choice"
            onClick={this.start}
          >
            <IconStart
              style={{ color: colors.charcoal1, height: "16px", top: "2px" }}
            />
            Start simulation
          </button>
        </div>
      </div>
    );
  }
}
